export const cancelButtonStyle = {
  minWidth: '40px',
  marginRight: '16px',
};
